export default __webpack_public_path__ + "static/media/logo_corsodyl.27c20431.svg";